import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getAiCategoriesAction,
  getAiCatSubAction,
  getAiPromptDetailsAction,
  addAiPromptAction,
  updateAiPromptAction,
} from "../../actions/AiActions";
import { Link } from "react-router-dom";
import { Close } from "@material-ui/icons";
import * as message from "./../../config/CommonMessages";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
class Aiprompt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || "AI Prompt",

      showLoader: false,
      aiPromptDetails: {},
      aiCategoryList: [],
      aiSubCategoryList: [],
      errors: {},

      category: "",
      subCategory: "",
      description: "",
      promptTemplate: "",
      placeholders: "",
      externalWebsite: "",
      documentId: "",
      isActive: false,
      isDefault: false,

      flag:
        this.props.history.location.state &&
        this.props.history.location.state.id
          ? "edit"
          : "add",
      promptId: "",
    };
  }

  componentDidMount() {
    this.props.getAiCategoriesAction().then((res) => {
      this.setState({ aiCategoryList: res.data.data });
    });
    if (this.state.flag === "edit") {
      let promptId = this.props.history.location.state.id;
      this.setState({ promptId: promptId });
      this.props.getAiPromptDetailsAction(promptId).then((res) => {
        if (res.data) {
          if (res.data.categoryId) {
            this.getCatSub(res.data.categoryId);
          }

          this.setState({
            category: res.data.categoryId ? res.data.categoryId : "",
            subCategory: res.data.subCategoryId ? res.data.subCategoryId : "",
            isActive: res.data.isActive ? res.data.isActive : false,
            isDefault: res.data.isDefault ? res.data.isDefault : false,
            description: res.data.description ? res.data.description : "",
            promptTemplate: res.data.promptTemplate
              ? res.data.promptTemplate
              : "",
            placeholders: res.data.placeholders ? res.data.placeholders : "",
            externalWebsite: res.data.externalWebsite
              ? res.data.externalWebsite
              : "",
            documentId: res.data.documentId ? res.data.documentId : "",
          });
        }
      });
    }
  }

  getCatSub = (catId) => {
    this.setState({
      showLoader: true,
    });

    this.props
      .getAiCatSubAction(catId)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            aiSubCategoryList: res.data,
            showLoader: false,
          });
        } else {
          this.setState({
            showLoader: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  findFormErrors() {
    const newErrors = {};
    if (!this.state.category || this.state.category === "") {
      newErrors.category = message.SELECT_CATEGORY;
    }
    if (!this.state.subCategory || this.state.subCategory === "") {
      newErrors.subCategory = message.SELECT_SUBCATEGORY;
    }
    if (!this.state.description || this.state.description === "") {
      newErrors.description = message.ENTER_PROMPT_DESCRIPTION;
    }
    if (!this.state.promptTemplate || this.state.promptTemplate === "") {
      newErrors.promptTemplate = message.ENTER_PROMPT_TEMPLATE;
    }
    if (this.state.externalWebsite) {
      var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (!regexp.test(this.state.externalWebsite)) {
        newErrors.externalWebsite = message.VALID_URL;
      }
    }
    if (this.state.documentId) {
      if (this.state.documentId.length > 20) {
        newErrors.documentId = message.MAX_DOCUMENT_ID;
      }
    }
    return newErrors;
  }

  handleSubmit = () => {
    const newErrors = this.findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      this.setState({ errors: newErrors });
    } else {
      this.setState({
        showLoader: true,
        errors: {},
      });
      let data = {
        categoryId: this.state.category,
        subCategoryId: this.state.subCategory,
        description: this.state.description,
        promptTemplate: this.state.promptTemplate,
        placeholders: this.state.placeholders,
        externalWebsite: this.state.externalWebsite,
        documentId: this.state.documentId,
        isActive: this.state.isActive,
        isDefault: this.state.isDefault,
      };
      if (this.state.flag === "add") {
        this.props
          .addAiPromptAction(data)
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                showLoader: false,
              });
              this.props.history.push({
                pathname: "/AiPromptsListing",
              });
            } else {
              this.setState({
                showLoader: false,
              });
            }
          })
          .catch((err) => {});
      } else if (this.state.flag === "edit") {
        this.props
          .updateAiPromptAction(data, this.state.promptId)
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                showLoader: false,
              });
              this.props.history.push({
                pathname: "/AiPromptsListing",
              });
            } else {
              this.setState({
                showLoader: false,
              });
            }
          })
          .catch((err) => {});
      }
    }
  };

  checkDefault(value) {
    if (this.state.isDefault) {
      if (!value) {
        //show popup that you cannot upate it.
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Active / Deactive</h2>
                  <p>
                    You cannot make this prompt status deactive because it is
                    default. If you want to deactivate this, please change
                    default.
                  </p>
                  <div className="react-confirm-alert-button-group">
                    <button onClick={onClose}>Close</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      } else {
        this.setState({
          isActive: value,
        });
      }
    } else {
      this.setState({
        isActive: value,
      });
    }
  }

  checkStatus(value) {
    if (!this.state.isActive) {
      if (value) {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Active / Deactive</h2>
                  <p>
                    You cannot change default status because it is currently
                    inactive.
                  </p>
                  <div className="react-confirm-alert-button-group">
                    <button onClick={onClose}>Close</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      } else {
        this.setState({
          isDefault: value,
        });
      }
    } else {
      this.setState({
        isDefault: value,
      });
    }
  }

  render() {
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col xs={12} sm={3}>
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>

          <Col xs={12} sm={6} />

          <Col xs={12} sm={3} align="right" className="transaction-close">
            <Link to="/AiPromptsListing" className="nav-link p-0 color-black">
              <Close
                style={{ stroke: "#fff", height: "40px", width: "40px" }}
              />
            </Link>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <section style={{ backgroundColor: "#eee" }}>
            <div className="container py-5">
              <div className="row">
                <div className="col-md-6 col-lg-8 col-xl-12">
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Label>
                        Category<span className="text-danger"> *</span>
                      </Form.Label>

                      <Form.Control
                        as="select"
                        name="category"
                        onChange={(e) => {
                          this.setState({
                            category: e.target.value,
                          });
                          this.getCatSub(e.target.value);
                        }}
                        value={this.state.category}
                        isInvalid={!!this.state.errors.category}
                      >
                        <option value="">Select Category</option>
                        {this.state.aiCategoryList.map((cat) => {
                          return (
                            <>
                              <option value={cat._id}>{cat.name}</option>
                            </>
                          );
                        })}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.category}
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Label>
                        Subcategory<span className="text-danger"> *</span>
                      </Form.Label>

                      <Form.Control
                        as="select"
                        name="subCategory"
                        onChange={(e) => {
                          this.setState({
                            subCategory: e.target.value,
                          });
                        }}
                        value={this.state.subCategory}
                        isInvalid={!!this.state.errors.subCategory}
                      >
                        <option value="">Select Subcategory</option>
                        {this.state.aiSubCategoryList.map((subCat) => {
                          return (
                            <>
                              <option value={subCat._id}>{subCat.name}</option>
                            </>
                          );
                        })}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.subCategory}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={12} sm={6}>
                      <Form.Label>
                        Prompt Template<span className="text-danger"> *</span>
                      </Form.Label>

                      <Form.Control
                        as="textarea"
                        rows={10}
                        value={this.state.promptTemplate}
                        onChange={(e) => {
                          this.setState({
                            promptTemplate: e.target.value,
                          });
                        }}
                        isInvalid={!!this.state.errors.promptTemplate}
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.promptTemplate}
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Label>Placeholders</Form.Label>
                      <Form.Group>
                        <div className="form-outline">
                          <textarea
                            className="form-control"
                            rows="3"
                            value={this.state.placeholders}
                            onChange={(e) => {
                              this.setState({
                                placeholders: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Label className="mt-3">
                        Prompt Description
                        <span className="text-danger"> *</span>
                      </Form.Label>

                      <Form.Control
                        as="textarea"
                        rows={4}
                        value={this.state.description}
                        onChange={(e) => {
                          this.setState({
                            description: e.target.value,
                          });
                        }}
                        isInvalid={!!this.state.errors.description}
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.description}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={12} sm={6} />
                  </Row>
                  <Row className="mt-2">
                    <Col xs={12} sm={6}>
                      <Form.Group>
                        <Form.Label>External Website</Form.Label>
                        <Form.Control
                          type="text"
                          name="externalWebsite"
                          value={this.state.externalWebsite}
                          onChange={(e) =>
                            this.setState({ externalWebsite: e.target.value })
                          }
                          isInvalid={!!this.state.errors.externalWebsite}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.externalWebsite}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Group>
                        <Form.Label>Document Id</Form.Label>
                        <Form.Control
                          type="text"
                          name="documentId"
                          value={this.state.documentId}
                          onChange={(e) =>
                            this.setState({ documentId: e.target.value })
                          }
                          isInvalid={!!this.state.errors.documentId}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.documentId}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Group style={{ display: "block" }}>
                        <Form.Check
                          name="isActive"
                          checked={this.state.isActive}
                          onChange={(e) => {
                            this.checkDefault(e.target.checked);
                          }}
                          style={{ display: "inline" }}
                        />
                        <Form.Label
                          style={{ display: "inline", paddingLeft: 10 }}
                        >
                          Status
                        </Form.Label>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group style={{ display: "block" }}>
                        <Form.Check
                          name="isDefault"
                          checked={this.state.isDefault}
                          onChange={(e) => {
                            this.checkStatus(e.target.checked);
                          }}
                          style={{ display: "inline" }}
                        />
                        <Form.Label
                          style={{ display: "inline", paddingLeft: 10 }}
                        >
                          Default
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="form-group pt-4 pb-4">
                    <Col>
                      <Button
                        type="button"
                        variant="primary"
                        className="btn-blue w-90 font-14 mr-3"
                        onClick={this.handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        variant="primary"
                        className="btn-blue btn-outlined w-90 font-14"
                        onClick={() =>
                          this.props.history.push("/AiPromptsListing")
                        }
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getAiCategoriesAction,
    getAiCatSubAction,
    getAiPromptDetailsAction,
    addAiPromptAction,
    updateAiPromptAction,
  }
)(Aiprompt);
